import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { WhatsAppContext } from 'context/Context';
import useWebSocket from 'react-use-websocket';
import { contextApp } from 'context';

const WhatsAppProvider = ({ children }) => {
 const [qr, setQr] = useState({});
 const { auth } = contextApp();
 const {
  sendJsonMessage,
  sendMessage,
  lastJsonMessage: broadcast
 } = useWebSocket('ws://localhost', {
  onOpen: async () => {
   console.log('Connected to App WS Server');
  },
  onMessage: () => {
   console.log(broadcast, 'llegando mensajes');

   if (broadcast?.ADMIN_QR?.qr?.type === 'Buffer' && Array.isArray(broadcast?.ADMIN_QR?.qr?.data)) {
    // Convierte los datos en un Uint8Array
    const uint8Array = new Uint8Array(broadcast?.ADMIN_QR?.qr?.data);

    // Convierte el Uint8Array en un ArrayBuffer
    const arrayBuffer = uint8Array.buffer;

    // Crea un objeto Blob a partir del ArrayBuffer
    const imageBlob = new Blob([arrayBuffer], { type: 'image/png' });

    // Crea una URL de objeto para la imagen
    const imageUrl = URL.createObjectURL(imageBlob);
    setQr({ [broadcast?.ADMIN_QR?.name]: imageUrl });
   }
  },
  queryParams: { token: auth?.token },
  onError: err => {
   console.log(err);
  },
  shouldReconnect: () => true, // CloseEvent
  reconnectInterval: 3000
 });

 return <WhatsAppContext.Provider value={{ sendJsonMessage, sendMessage, broadcast, qr }}>{children}</WhatsAppContext.Provider>;
};

WhatsAppProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default WhatsAppProvider;
